import { defineStore } from "pinia";
import { CaptionModel } from "../utils/captionModel";
import { AvailableCaption } from "../utils/availableCaptionModel";
import { Language, languages } from "../utils/languageList";
import Player from "video.js/dist/types/player";
import { SelectedAudio } from "../utils/selectedAudio";
interface AudioState {
  processingStarted: boolean;
  receivedCaption: boolean;
  hasCaption: boolean;
  hasVideo: boolean;
  isNotValidLink: boolean;
  notReadyYet: boolean;
  isTargetListOpen: boolean;
  isFromNotification: boolean;
  isTargetLanguageSelected: boolean;
  balanceNotEnough: boolean;
  computePricing: boolean;
  captions: CaptionModel[];
  availableCaptions: AvailableCaption[];
  activeCaptionLang: string | "";
  userInput: string | "";
  originalAudioSubtitle: string | "";
  translatedAudioSubtitle: string | "";
  translatedText: string | "";
  prebuildAudioSubtitle: string | ``;
  originalText: string | ``;
  searchQuery: string | "";
  myLanguagesList: Language[];
  isTranslationListOpened: boolean;
  translationLanguage: Language;
  originalLanguage: Language;
  isOpen: boolean;
  player: any | null;
  currentTime: number;
  currentCaptions: CaptionModel[];
  currentRequestId: string | "";
  mountPlayer: boolean;
  videoPlayer : Player | null;
  textTranslationPrice: number;
  selectedAudio: SelectedAudio;
  userInputAudioLink: string | "";
  isTranslationPreview: boolean;
  audioTranscriptionCost: number;
  processingStatus: string | "";
  progressBar: number;
  ffmpegPercentage: number;
  fileUploadPercentage: number;
  fileUploaded: boolean;
  showDownloadTypes:boolean;
  fontFamily: string | "";
  fontSizePercent: number;
  fontFamilyListShow: boolean;
  audioContent: string | "";
  audioContentTranslated: string | "";
  selectedVoice: string | "";
  selectedVoiceTranslated: string | "";
  defaultOriginalAudioSubtitle: string | ``;
  defaultTranslatedAudioSubtitle: string | ``;
  defaultOriginalText: string | ``;
  defaultTranslatedText: string | ``;
  pickedColor: any | null,
  originalJsonContent: any | null,
  latestTranslationTarget: string | '',
  showTextTab: boolean,
  processingLink: boolean,
  fileName: string | '',
  originalSummarizedText: string | ``;
  translatedSummarizedText: string | "";
  showOriginalSummarized: boolean;
  showTranslatedSummarized: boolean;
  origineTokenValue: number;
  translatedTokenValue: number;
  summarizesData: any[];
  selectedSummarizedLanguage: string;
  translatedSummarizesLangs: any[];
  latestTranslationId: string | "";
  audioSource: any;
  audioSourceTranslated: any;
  isMultiLanguageMode: boolean;
  selectedTargetLanguages: Language[];
  bulkTextTranslations: Record<string, string>;
  currentDisplayLanguage: Language;
  parsedCaptionsWithSpeakers: CaptionModel[];
  /** Help modal "here" links: scroll target when result panel mounts (ids: ttsPanel, textPanel, …) */
  pendingHelpScrollSectionId: string | null;
}

export const useAudioStore = defineStore("audioStore", {
  state: (): AudioState => ({
    processingStarted: false,
    receivedCaption: false,
    hasCaption: false,
    hasVideo: false,
    isNotValidLink: false,
    captions: [],
    availableCaptions: [],
    activeCaptionLang: "",
    userInput: "",
    originalAudioSubtitle: "",
    translatedAudioSubtitle: "",
    prebuildAudioSubtitle: ``,
    translatedText: "",
    originalText: "",
    notReadyYet: false,
    isFromNotification: false,
    isTargetListOpen: false,
    isTargetLanguageSelected: false,
    searchQuery: "",
    myLanguagesList: languages,
    isTranslationListOpened: false,
    translationLanguage: {
      langName: "Arabic",
      langCode: "ar",
      countryCode: "sa",
    },
    originalLanguage: {
      langName: "",
      langCode: "",
      countryCode: "",
    },
    isOpen: false,
    balanceNotEnough: false,
    computePricing: false,
    player: null,
    currentTime: 0,
    currentCaptions: [],
    currentRequestId: "",
    mountPlayer: false,
    videoPlayer: null,
    textTranslationPrice: 0,
    selectedAudio: {name: ""},
    userInputAudioLink: "",
    isTranslationPreview: false,
    audioTranscriptionCost: 0,
    processingStatus: "",
    progressBar: 0,
    ffmpegPercentage: 0,
    fileUploadPercentage: 0,
    fileUploaded: false,
    fontFamily: "Arial",
    showDownloadTypes: false,
    fontSizePercent: 50,
    fontFamilyListShow: false,
    audioContent: "",
    audioContentTranslated: "",
    selectedVoice: "none",
    selectedVoiceTranslated: "none",
    defaultOriginalAudioSubtitle: ``,
    defaultTranslatedAudioSubtitle: ``,
    defaultOriginalText: "",
    defaultTranslatedText: "",
    pickedColor: "000000",
    originalJsonContent: null,
    latestTranslationTarget: "",
    showTextTab: true,
    processingLink: false,
    fileName: '',
    originalSummarizedText: "",
    translatedSummarizedText: "",
    showOriginalSummarized: false,
    showTranslatedSummarized: false,
    origineTokenValue: 120,
    translatedTokenValue: 120,
    summarizesData: [],
    selectedSummarizedLanguage: "ar",
    translatedSummarizesLangs: [],
    latestTranslationId: "",
    audioSource: null,
    audioSourceTranslated: null,
    isMultiLanguageMode: false,
    selectedTargetLanguages: [],
    bulkTextTranslations: {},
    currentDisplayLanguage: {
      langName: "Arabic",
      langCode: "ar",
      countryCode: "sa",
    },
    parsedCaptionsWithSpeakers: [],
    pendingHelpScrollSectionId: null,
}),

  actions: {
    setRequest(requestId: string): void {},
  },
});
